import React, { useState, useEffect } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { useContactModal } from '../components/ContactModalContext';
import reg_event from '../img/hero_photo.png';

export default function SignUp() {
  const { strings } = useLanguage();

  const { openContact } = useContactModal();

  return (
    <div>
<section className="hero">
  <div class="hero-content">
    <div class="eyebrow">Членство · RPSwiss · 2026</div>
    <h1>Членство<br />в <em>RPSwiss</em></h1>
    <p className="hero-sub">Сильное окружение<br />для жизни, карьеры и бизнеса в Швейцарии</p>
    <div className="hero-btns">
      <a href="#membership" className="btn-gold">Вступить в ассоциацию</a>
      <a href="https://instagram.com/rpswiss_ch" target="_blank" className="btn-outline">@rpswiss_ch</a>
    </div>
  </div>
  <div class="hero-photo">
    <img src={reg_event} alt="Мероприятие RPSwiss" />
  </div>
</section>

<div className="gold-line"></div>


<section className="section" id="membership">
  <div className="section-tag">Членство</div>

  <div className="membership-banner">
    <div class="membership-bg-num">250</div>
    <div>
      <div className="membership-sublabel">Единый пакет · Для всех участников</div>
      <div className="membership-price">250 <span>CHF / год</span></div>
      <div className="membership-desc">Полный доступ к сети, событиям и возможностям сообщества — для специалистов и предпринимателей.</div>
    </div>
    <div className="membership-right">
      <a href="https://buy.stripe.com/5kQbIT8uuaoY8Oc1i7cs805" className="btn-dark">Вступить сейчас</a>
      <span style={{ fontSize: '10px', letterSpacing: '0.15em', textTransform: 'uppercase', color: 'rgba(13,27,42,0.5)' }}>· Профессиональное членство ·</span>
    </div>
  </div>

  <div className="features-grid">
    <div className="feature-block">
      <div className="feature-block-label">Сеть и коммуникации</div>
      <ul className="feature-list">
        <li><strong>Закрытая база специалистов и компаний</strong> — поиск и прямой контакт (доступ по паролю на сайте)</li>
        <li><strong>Доступ в закрытый чат RPSwiss</strong> — запросы на специалистов, совместные проекты, коллаборации</li>
        <li>Рекомендации внутри сообщества и партнёрам ассоциации — под конкретные запросы</li>
        <li>Ежемесячная рассылка — новости Швейцарии, налоги, адаптация, события и новые участники сообщества</li>
      </ul>
    </div>
    <div className="feature-block">
      <div className="feature-block-label">Мероприятия</div>
      <ul className="feature-list">
        <li><strong>От 10 онлайн-встреч в год</strong> — mastermind из разных сфер, обмен опытом, новые контакты (включено в членство). По мере роста сообщества количество событий будет пополняться.</li>
        <li>Доступ на <strong>4 офлайн-мероприятия</strong> ассоциации в год — скидка 20%</li>
        <li>Доступ на мероприятия от партнёров ассоциации — скидка 20%</li>
        <li>Скидка 20% на дополнительные открытые воркшопы и события ассоциации</li>
      </ul>
    </div>
  </div>

  <div className="features-grid" style={{ marginTop: '2px' }}>
    <div className="feature-block">
      <div class="feature-block-label">Видимость</div>
      <ul class="feature-list">
        <li>Профиль в закрытой базе участников</li>
        <li>Представление новых участников в рассылке и сторис ассоциации</li>
        <li>Представление новых участников в закрытом чате сообщества</li>
      </ul>
    </div>
    <div className="feature-block" style={{ display: 'flex', alignItems: 'center' }}>
      <div>
        <div class="feature-block-label">Для кого</div>
        <p style={{ fontSize: '13px', fontWeight: '300', color: 'var(--muted)', lineHeight: '1.8' }}>Специалисты в найме, предприниматели, фрилансеры и все, кто говорит по-русски и строит свой путь в Швейцарии — вне зависимости от страны происхождения.</p>
      </div>
    </div>
  </div>

</section>

  <div className="gold-line"></div>


<section className="section" id="services">
  <div className="section-tag">Платные услуги</div>

  <div style={{ marginBottom: '40px', maxWidth: '680px' }}>
    <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 'clamp(26px,3vw,40px)', fontWeight: '300', color: 'var(--cream)', lineHeight: '1.25', marginBottom: '16px' }}>Дополнительные инструменты<br /><em>для продвижения</em></h2>
    <p style={{ fontSize: '14px', fontWeight: '300', color: 'var(--muted)', lineHeight: '1.85' }}>Доступны всем участникам и компаниям — для размещения контента, вакансий и организации событий внутри сети.</p>
  </div>

  <div className="services-row">
    <div className="service-card">
      <div className="service-name">Реклама в чате или сторис</div>
      <div className="service-desc">Размещение в чате RPSwiss или в Instagram-сторис ассоциации</div>
    </div>
    <div class="service-card">
      <div class="service-name">Вакансия на портале</div>
      <div class="service-desc">Размещение на портале вакансий RPSwiss</div>
    </div>
    <div class="service-card">
      <div class="service-name">Событие в календарь</div>
      <div class="service-desc">Добавление мероприятия в календарь RPSwiss</div>
    </div>
    <div class="service-card">
      <div class="service-name">Консалтинг по ивентам</div>
      <div class="service-desc">Организация мероприятий совместно с командой RPSwiss</div>
    </div>
    <div class="service-card">
      <div class="service-name">Партнёрское мероприятие</div>
      <div class="service-desc">Совместное событие с RPSwiss — по договорённости</div>
    </div>
  </div>

    <div style={{ marginTop: '24px', padding: '28px 36px', border: '1px solid rgba(201,168,76,0.2)', background: 'rgba(201,168,76,0.03)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '20px' }}>
      <p style={{ fontSize: '13px', fontWeight: '300', color: 'var(--muted)', lineHeight: '1.7' }}>Свяжитесь с нами, чтобы узнать подробности о стоимости дополнительного продвижения.</p>
      <button type="button" onClick={() => openContact()} className="btn-outline" style={{ whiteSpace: 'nowrap' }}>Написать нам</button>
    </div>

</section>

<div className="gold-line"></div>


<section className="section" id="catalog">
  <div className="section-tag">Каталог специалистов · Открытая база</div>

  <div className="catalog-box">
    <div className="catalog-left">
      <div class="catalog-eyebrow">Открытая база · Бесплатно</div>
      <h2>Ваш профиль<br />в <em>открытой базе</em></h2>
      <p>Каталог специалистов RPSwiss — это открытая база, доступная всем желающим. Разместить профиль может любой специалист или компания.</p>

      <ol className="catalog-steps">
        <li className="catalog-step">
          <div className="catalog-step-num">01</div>
          <div className="catalog-step-text">
            <strong>Заполните анкету</strong>
            Расскажите о своей сфере, опыте, услугах или проекте — мы оформим ваш профиль.
          </div>
        </li>
        <li className="catalog-step">
          <div className="catalog-step-num">02</div>
          <div className="catalog-step-text">
            <strong>Попадите в каталог</strong>
            Ваш профиль появляется в открытой базе — его найдут по специализации, имени или через поиск.
          </div>
        </li>
        <li className="catalog-step">
          <div className="catalog-step-num">03</div>
          <div className="catalog-step-text">
            <strong>Получайте запросы</strong>
            Любой посетитель сайта и члены сообщества могут найти вас напрямую и обратиться с запросом.
          </div>
        </li>
      </ol>
    </div>

    <div className="catalog-right">
      <div className="catalog-right-label">Что входит в профиль</div>
      <ul className="catalog-includes">
        <li>
          <div class="catalog-includes-title">Имя и специализация</div>
          <div class="catalog-includes-sub">Ваша профессия, сфера деятельности и ключевые компетенции</div>
        </li>
        <li>
          <div class="catalog-includes-title">Контактные данные</div>
          <div class="catalog-includes-sub">Прямой контакт для членов сообщества — почта, LinkedIn или сайт</div>
        </li>
        <li>
          <div class="catalog-includes-title">О себе или компании</div>
          <div class="catalog-includes-sub">Краткое описание опыта, проектов или услуг, которые вы предлагаете</div>
        </li>
        <li>
          <div class="catalog-includes-title">Представление в рассылке</div>
          <div class="catalog-includes-sub">Новые участники анонсируются в ежемесячной рассылке и сторис ассоциации</div>
        </li>
      </ul>

      <div style={{ padding: '24px 28px', border: '1px solid rgba(201,168,76,0.2)', background: 'rgba(201,168,76,0.04)' }}>
        <div style={{ fontSize: '11px', fontWeight: '600', letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--gold)', marginBottom: '10px' }}>Разместить профиль</div>
        <p style={{ fontSize: '13px', fontWeight: '300', color: 'var(--muted)', lineHeight: '1.75', marginBottom: '16px' }}>Каталог открыт для всех. Заполните заявку — и мы добавим ваш профиль в базу специалистов RPSwiss.</p>
        <a href="/register_professional" target="_blank" className="btn-gold" style={{ fontSize: '10px', padding: '12px 28px' }}>Заполнить заявку</a>
      </div>
    </div>
  </div>

</section>


<div class="gold-line"></div>
<section class="section" id="sponsors">
  <div class="section-tag">Для компаний · Спонсорство</div>

  <div style={{ marginBottom: '48px', maxWidth: '680px' }}>
    <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 'clamp(26px,3vw,40px)', fontWeight: '300', color: 'var(--cream)', lineHeight: '1.25', marginBottom: '16px' }}>Прямой доступ<br />к <em>профессиональной аудитории</em></h2>
    <p style={{ fontSize: '14px', fontWeight: '300', color: 'var(--muted)', lineHeight: '1.85' }}>Для найма, партнёрств и продвижения внутри сети специалистов.</p>
  </div>

  <div class="sponsors-grid">
    <div class="sponsor-card">
      <div class="sponsor-level">Уровень 1</div>
      <div class="sponsor-name">Размещение</div>
      <div class="sponsor-price">1 000 CHF / год · Видимость и присутствие в сети</div>
      <ul class="sponsor-features">
        <li>Логотип и присутствие на сайте ассоциации</li>
        <li>Доступ к базе участников сообщества</li>
        <li><strong>1 упоминание в месяц</strong> — рассылка и сторис (спонсорский контент)</li>
        <li><strong>1 вакансия в месяц</strong> на портале RPSwiss</li>
        <li>Логотип на рекламных носителях открытых мероприятий</li>
        <li>Участие спикером в релевантных встречах</li>
        <li>Закрытые партнёрские форматы — бизнес-встречи, нетворкинг</li>
      </ul>
    </div>

    <div class="sponsor-card featured">
      <div class="sponsor-level">Уровень 2</div>
      <div class="sponsor-name">Продвижение</div>
      <div class="sponsor-price">2 000 CHF / год · Расширенное присутствие и активность</div>
      <ul class="sponsor-features">
        <li>Логотип и присутствие на сайте ассоциации</li>
        <li>Доступ к базе участников сообщества</li>
        <li>Логотип на рекламных носителях открытых мероприятий</li>
        <li>Участие спикером в релевантных встречах</li>
        <li>Закрытые партнёрские форматы — бизнес-встречи, нетворкинг</li>
        <li><strong>2 публикации в месяц</strong> — рассылка или Instagram</li>
        <li><strong>2 вакансии в месяц</strong> на портале RPSwiss</li>
        <li><strong>1 мероприятие в год</strong> для сообщества</li>
      </ul>
    </div>

    <div class="sponsor-card" style={{ gridColumn: '1/-1', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '32px', alignItems: 'start' }}>
      <div>
        <div class="sponsor-level">Уровень 3</div>
        <div class="sponsor-name">Партнёрская работа с сетью</div>
        <div class="sponsor-price">3 000 CHF / год · Максимальная интеграция в сообщество</div>
      </div>
      <ul class="sponsor-features">
        <li>Всё из уровней 1 и 2</li>
        <li><strong>Неограниченные публикации</strong> — рассылка, Instagram, LinkedIn, Facebook, WhatsApp, сайт</li>
        <li><strong>Неограниченные вакансии</strong> на всех каналах сообщества</li>
        <li><strong>2 мероприятия в год</strong> для сообщества</li>
        <li><strong>Статус ключевого партнёра</strong> — выделенное присутствие во всех коммуникациях</li>
      </ul>
    </div>
  </div>

</section>


<div class="gold-line"></div>


  <div class="cta" id="join">
  <h2>Вступить в RPSwiss</h2>
  <p>Профессиональное сообщество русскоязычных специалистов в Швейцарии</p>
    <div class="cta-btns">
    <button type="button" onClick={() => openContact()} class="btn-gold">Написать нам</button>
    <a href="https://instagram.com/rpswiss_ch" target="_blank" class="btn-outline">@rpswiss_ch</a>
  </div>
</div>



    </div>
  );
} 